// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");
var LanguageSelectorPosition$ReactHooksTemplate = require("./LanguageSelectorPosition.res.js");

function LanguageSelector(props) {
  var __selectWidthClass = props.selectWidthClass;
  var onLanguageChange = props.onLanguageChange;
  var surveyLanguages = props.surveyLanguages;
  var selectWidthClass = __selectWidthClass !== undefined ? __selectWidthClass : LanguageSelectorPosition$ReactHooksTemplate.selectWidthClass(LanguageSelectorPosition$ReactHooksTemplate.default);
  var wrapperClass = LanguageSelectorPosition$ReactHooksTemplate.selectHeightClass + " " + selectWidthClass + " relative inline-flex items-center";
  var handleChange = function ($$event) {
    Curry._1(onLanguageChange, $$event);
    $$event.target.blur();
  };
  if (surveyLanguages && surveyLanguages.tl) {
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("select", {
                        children: Belt_List.toArray(Belt_List.map(surveyLanguages, (function (x) {
                                    return JsxRuntime.jsx("option", {
                                                children: SurveyLanguage$ReactHooksTemplate.name(x),
                                                value: SurveyLanguage$ReactHooksTemplate.name(x)
                                              }, SurveyLanguage$ReactHooksTemplate.code(x));
                                  }))),
                        "aria-label": "Select survey language",
                        className: "h-full w-full appearance-none text-left text-sm border border-gray-200 rounded-lg cursor-pointer outline-none bg-white pl-3 pr-8 text-gray-600 focus:outline-none focus:ring-0 focus:border-gray-200",
                        value: SurveyLanguage$ReactHooksTemplate.name(props.languageSelected),
                        onChange: handleChange
                      }),
                  JsxRuntime.jsx("img", {
                        className: "pointer-events-none absolute right-2.5 top-1/2 h-3 w-3 transform -translate-y-1/2 filter-gray-400 opacity-50",
                        alt: "",
                        src: Image$ReactHooksTemplate.chevronDown
                      })
                ],
                className: wrapperClass
              });
  } else {
    return null;
  }
}

var make = LanguageSelector;

exports.make = make;
/* react/jsx-runtime Not a pure module */
